import React, { FC } from "react";

export const CompleteOrderIcon: FC = () => {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20.75" cy="20" r="20" fill="#FF947A" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.75 14C12.75 11.7909 14.5409 10 16.75 10H22.75V14C22.75 16.2091 24.5409 18 26.75 18H28.75V26C28.75 28.2091 26.9591 30 24.75 30H16.75C14.5409 30 12.75 28.2091 12.75 26V14ZM16.75 19C16.1977 19 15.75 19.4477 15.75 20C15.75 20.5523 16.1977 21 16.75 21H18.75C19.3023 21 19.75 20.5523 19.75 20C19.75 19.4477 19.3023 19 18.75 19H16.75ZM16.75 23C16.1977 23 15.75 23.4477 15.75 24C15.75 24.5523 16.1977 25 16.75 25H20.75C21.3023 25 21.75 24.5523 21.75 24C21.75 23.4477 21.3023 23 20.75 23H16.75ZM25.4318 12.1988L25.3009 14.1629C25.2606 14.7666 25.7615 15.2674 26.3652 15.2272L28.3292 15.0962C29.1865 15.0391 29.5774 13.9989 28.9698 13.3913L27.1367 11.5582C26.5292 10.9507 25.4889 11.3415 25.4318 12.1988Z"
        fill="white"
      />
    </svg>
  );
};
